import { createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { jsx } from 'react/jsx-runtime';
import Chip from '@mui/material/Chip';
import { universeStatusChip } from '@storyworm/ssup-data/status';
export { licenceStatus } from '@storyworm/ssup-data/status';

// src/theme.ts
var ssupTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#2b7fff" },
    background: {
      default: "#0f1115",
      paper: "#1a1d23"
    },
    divider: "#2a2f38",
    success: { main: "#4ade80" },
    error: { main: "#ff6b6b" },
    warning: { main: "#facc15" },
    text: {
      primary: "#e7e9ee",
      secondary: "#9aa3b2"
    }
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: ['"Roboto"', "system-ui", "-apple-system", '"Segoe UI"', "sans-serif"].join(","),
    h1: { fontSize: 22, fontWeight: 700 },
    h2: { fontSize: 16, fontWeight: 600 }
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: "none", fontWeight: 600 } }
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none", border: "1px solid #2a2f38" }
      }
    }
  }
});

// src/docTheme.ts
var PD_DARK_THEME = {
  ["--pd-primary"]: "#2b7fff",
  ["--pd-panel"]: "#1a1d23",
  ["--pd-panel-2"]: "#12151b",
  ["--pd-border"]: "#2a2f38",
  ["--pd-fg"]: "#e7e9ee",
  ["--pd-muted"]: "#9aa3b2",
  ["--pd-success-br"]: "#4ade80",
  ["--pd-warn-br"]: "#facc15"
};
function Logo({ maxWidth = 170, sx }) {
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "img",
      src: "/logo.png",
      alt: "StoryWorm",
      sx: [
        { width: "100%", maxWidth, height: "auto", display: "block" },
        ...Array.isArray(sx) ? sx : [sx]
      ]
    }
  );
}
var TONE_TO_COLOR = {
  neutral: "default",
  info: "info",
  success: "success",
  warning: "warning"
};
function toneToColor(tone) {
  return TONE_TO_COLOR[tone];
}
function universeChipProps(universe) {
  const { label, tone } = universeStatusChip(universe);
  return { label, color: toneToColor(tone) };
}
function UniverseStatusChip({
  universe,
  size = "small"
}) {
  const { label, color } = universeChipProps(universe);
  return /* @__PURE__ */ jsx(Chip, { label, color, size, variant: "outlined" });
}

export { Logo, PD_DARK_THEME, UniverseStatusChip, ssupTheme, toneToColor, universeChipProps };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map